import { WhatsApp } from "@mui/icons-material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { Paper, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { ptBRGrid } from "../../../Boletos/tableConfig/translateptBR";
import Cookies from "js-cookie";
import { supportNumber } from "../../../../../utils/supportNumber";

const Desktop = ({ newCertificate, nome, server, setURL, setOpenDialog }) => {
  return (
    <Paper sx={{ p: 2 }}>
      <DataGrid
        rows={newCertificate}
        sx={{
          ".MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-row:hover": {
            cursor: "pointer",
          },
        }}
        columns={[
          { field: "numnota", headerName: "Nota Fiscal", width: 100 },
          { field: "descrprod", headerName: "Produto", width: 250 },
          { field: "serie", headerName: "Série", width: 150 },
          {
            field: "cert",
            headerName: "Certificado",
            width: 250,
            renderCell: (params) => {
              return (
                <Button
                  variant="outlined"
                  disabled={params.row.unique[9] === "1010200"}
                  endIcon={<WorkspacePremiumIcon />}
                  onClick={() => {
                    const options = {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Authorization: "Bearer " + Cookies.get("bearer"),
                      },
                      body: new URLSearchParams({
                        nomeparc: nome,
                        jsonid: localStorage.getItem("token"),
                        serie: params.row.unique[10],
                        nomeprod: params.row.unique[7],
                        codprod: params.row.unique[6],
                        cnpj: nome?.trim?.(),
                        bu: localStorage.getItem("segmento"),
                        series: JSON.stringify([params.row.unique[10]]),
                      }),
                    };

                    fetch(`${server}portalCliente/gera_certificado`, options)
                      .then((response) => response.text())
                      .then((response) => {
                        setURL(response);
                        setOpenDialog(true);
                      })
                      .catch((err) => console.error(err));
                  }}
                >
                  Acessar Certificado
                </Button>
              );
            },
          },
          {
            field: "zap",
            headerName: "WhatsApp",
            width: 150,
            renderCell: (params) => {
              return (
                <Button
                  variant="outlined"
                  color="success"
                  disabled={params.row.unique[9] === "1010200"}
                  endIcon={<WhatsApp />}
                  href={`https://wa.me/${supportNumber.whatsApp}?text=Ol%C3%A1%21+Gostaria+de+falar+sobre+os+consum%C3%ADveis`}
                >
                  WhatsApp
                </Button>
              );
            },
          },
        ]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        localeText={ptBRGrid}
      />
    </Paper>
  );
};

export default Desktop;
